import { useQuery } from '@tanstack/react-query';
import { IFiltersValues } from '@diana/core';
import { profileQuery } from '../queries/Profile';
import { convertFiltersToExportQuery } from '../utils/convertFiltersToQuery';

export const useProfileQuery = (filtersValues: IFiltersValues) => {
  const getProfileQuery = profileQuery.getProfile();

  const { refetch, isLoading, isRefetching, isFetching, isPending } = useQuery({
    queryKey: [getProfileQuery.key, filtersValues],
    queryFn: async () => {
      const response = await getProfileQuery.fn({
        params: convertFiltersToExportQuery(filtersValues),
      });
      return response;
    },
    enabled: false, // Disables automatic fetching
  });

  return { refetch, isLoading, isFetching, isRefetching, isPending };
};
